import { AppContext, AppAction } from "helpers/context";
import { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as LayersSvg } from "assets/icon_layers.svg";
import Expander from "../expander/expander";
import HailExpander from "../expander/hailExpander/hailExpander"
import styles from "./layers.module.scss";
import { getRiskAnalysis } from "api/layer"
import { CircularProgress, Card, Stack } from "@mui/material";
import FathomGlobalAnalysis from "assets/fathom_global_analysis.svg"
import FathomGlobalAnalysisChina from "assets/fathom_global_analysis_china.svg"
import TryAgain from "components/tryAgain/tryAgain";

function Layers() {
  const [context, dispatch] = useContext(AppContext);
  const [t] = useTranslation();
  const [layerInfoList, setLayerInfoList] = useState<any[]>([]);
  const [layerCount, setLayerCount] = useState(0);
  const requestControllers = useRef<{ [key: string]: AbortController }>({});


  const handleCreateData = async (isRest = false) => {
    if (context.layerList) {
      let list = isRest ? [] : [...layerInfoList];
      let num = 0;

      let sortArr: any = [];
      context.layerList.forEach((item) => {
        item.children.forEach((i) => {
          let isFind = list.find((v: any) => v.id === i.id);
          if (i.checked) {
            num++
          }
          if (isFind) {
            isFind.checked = i.checked;
            sortArr.push(isFind);
          } else if (i.checked) {
            sortArr.push({ ...i });
          }
        });
      });
      setLayerCount(num);
      setLayerInfoList(sortArr);

      sortArr.forEach(async (i: any) => {
        if (i.checked && !i.valueLabel) {
          // 命中条件且未加载值时，发起请求
          if (!requestControllers.current[i.id]) {
            const params = {
              longitude: context.currentMultipleLocationInfo
                ? context.currentMultipleLocationInfo.longitudeWgs
                : context.searchLocationInfo.en.location.split(",")[0],
              latitude: context.currentMultipleLocationInfo
                ? context.currentMultipleLocationInfo.latitudeWgs
                : context.searchLocationInfo.en.location.split(",")[1],
              queryLayers: i.id,
              country: context.currentMultipleLocationInfo
                ? context.currentMultipleLocationInfo.country
                : context.searchLocationInfo.en.country,
              oversea: context.currentMultipleLocationInfo
                ? true
                : context.searchLocationInfo.en.oversea,
              spatial: context.currentMultipleLocationInfo
                ? "wgs"
                : context.searchLocationInfo.en.spatial,
            };

            hanleGetRiskAnalysis(params, i, 0)
          }
        } else if (requestControllers.current[i.id]) {
          requestControllers.current[i.id].abort();
          delete requestControllers.current[i.id];
        }
      })

    }
  };

  const hanleGetRiskAnalysis = (params: any, dataItem: any, num: number) => {
    const controller = new AbortController();
    requestControllers.current[dataItem.id] = controller;
    getRiskAnalysis(params, controller.signal)
      .then((result: any) => {
        if (result.code === 200 && result.data?.results?.results![0]) {
          let item = result.data.results.results[0];
          setLayerInfoList((prevData) => {
            return prevData.map(ite => {
              if (ite.id === item.layerId) {
                return { ...ite, ...item, error: false }
              }
              return ite
            })
          });
          delete requestControllers.current[dataItem.id]; // 请求完成后清理控制器
        } else {
          if (num < 10) {
            hanleGetRiskAnalysis(params, dataItem, ++num);
          } else {
            setLayerInfoList((prevData) => {
              return prevData.map(ite => {
                if (ite.id === dataItem.id) {
                  return { ...ite, error: true }
                }
                return ite
              })
            })
            delete requestControllers.current[dataItem.id];
          }
        }
      })
      .catch((error) => {
        if (num < 10) {
          hanleGetRiskAnalysis(params, dataItem, ++num);
        } else {
          setLayerInfoList((prevData) => {
            return prevData.map(ite => {
              if (ite.id === dataItem.id) {
                return { ...ite, error: true }
              }
              return ite
            })
          })
          delete requestControllers.current[dataItem.id];
        }
      })
  }

  useEffect(() => {
    handleCreateData()
  }, [context.layerList])

  useEffect(() => {
    handleCreateData(true)
  }, [context.currentMultipleLocationInfo, context.searchLocationInfo])

  useEffect(() => {
    handleCreateData()
  }, [])

  const handleContent = () => {
    if (Object.keys(requestControllers.current).length) {
      return (<div className="flex flex-col items-center justify-center py-2">
        <CircularProgress color="success" className="my-3" />
        <div>{t("single.loadingLayerAnalyses")}</div>
      </div>)
    } else {
      return (<>
        {layerInfoList.map((item) => (item.checked && (
          <Card
            variant="outlined"
            style={{
              borderRadius: "4px",
              marginTop: "15px",
              marginBottom: "15px",
              marginLeft: "10px",
              border: "1px solid var(--Surface-Border---Outline, rgba(33, 33, 33, .12))",
              background: "#fff",
              boxShadow: "0 1px 6px #0000001f, 0 1px 4px #0000001f",
            }}
            key={item.id}
          >
            <Expander layerInfo={item}>
              {(item.details && JSON.stringify(item.details) !== "{}") &&
                (<>
                  <Stack spacing={0.3} className={styles.detail}>
                    {
                      item.layerId === "CS_Hail_Global_SwissRe" ?
                        <HailExpander layerInfo={item} />
                        :
                        (<>
                          {Object.keys(item.details).reverse().map(e => {
                            return (
                              <Stack key={e} direction="row" spacing={2}>
                                <div className={styles.key}>
                                  {t("legend." + e).startsWith("legend.") ? e : t("legend." + e)}:
                                </div>
                                <div className={styles.value}>
                                  {t("legend." + item.details[e]).startsWith("legend.")
                                    ? item.details[e]
                                    : t("legend." + item.details[e])}
                                </div>
                              </Stack>
                            );
                          })}
                          {item.additionalDetails && (Object.keys(item.additionalDetails).reverse().map(e => {
                            return (
                              <Stack key={e} direction="row" spacing={2}>
                                <div className={styles.key}>
                                  {t("legend." + e).startsWith("legend.") ? e : t("legend." + e)}:
                                </div>
                                <div className={styles.value}>
                                  {t("legend." + item.additionalDetails[e]).startsWith("legend.")
                                    ? item.additionalDetails[e]
                                    : t("legend." + item.additionalDetails[e])}
                                </div>
                              </Stack>
                            );
                          }))}
                          {!item.layerId.includes("Fathom") && (<Stack direction="row" spacing={2}>
                            <div className={styles.key}>
                              {t("single.intensityValue")}:
                            </div>
                            <div className={styles.value}>{item.intensity}</div>
                          </Stack>)}
                        </>)
                    }
                  </Stack>
                  {item.layerId.includes("Fathom") && (<div className={styles.fathomLayer}>
                    <div className={styles.fathomHeader}>
                      <span className={styles.fathomHeaderContent}><div className="material-icons">check</div>{t("legend.Flood Depth")}</span>
                      <span className={styles.fathomHeaderContent}><div className="material-icons">check</div>{t("legend.5-1000 Years Return Period")}</span>
                    </div>
                    <div
                      className={styles.fathomFoot}
                      style={{
                        backgroundImage: `url(${context.language === "en" ? FathomGlobalAnalysis : FathomGlobalAnalysisChina})`
                      }}
                    >
                      <div className={styles.fathomFootContent}>
                        <div
                          className="material-icons"
                          style={{
                            color: "#0009",
                            height: "24px",
                            width: "24px",
                            marginRight: "10px",
                            position: "absolute",
                            top: "16px"
                          }}
                        >lock_open</div>
                        <div
                          style={{
                            width: "225px",
                            textIndent: "34px",
                            marginTop: "10px"
                          }}
                        >
                          {t("single.unlockFathom")}
                          <span
                            onClick={() => {
                              if (context.menu.find((item) => item.id === "102004" && item.status === "1")) {
                                dispatch({ type: AppAction.setSingleAnalyseModal, payload: { type: "1", selectId: item.layerId } });
                              } else {
                                dispatch({ type: AppAction.setFathomPermissionDialog, payload: true })
                              }
                            }}
                          >{t("single.analyzeLocation")}</span> {t("single.toUnlockMoreInsights")}
                        </div>
                      </div>
                    </div>
                  </div>)}
                </>)}
            </Expander>
          </Card>
        )))}
      </>)
    }
  }

  return layerCount > 0 ? (<div className={styles.layers}>
    <div className={styles.header}>
      <div className={styles.icon}>
        <LayersSvg />
      </div>
      <div>{t("layers.title")}</div>
      <div className={styles.count}>
        {layerCount}{" "}
        {layerCount === 1 ? t("layers.singular") : t("layers.title")}
      </div>
    </div>
    {handleContent()}
  </div >) : null;
}

export default Layers;


